export default "/assets/images/pollen-video.83263f835043d872.mp4";